<div class="row">
  <main class="main col-lg-9 col-md-12">
    <cir-pub-highlights [showArchive]="false"></cir-pub-highlights>
  </main>
</div>

